var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt--7",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('reports-table',{ref:"table",attrs:{"title":"Reports"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }